import { render, staticRenderFns } from "./Fiserv-widgets-guid.vue?vue&type=template&id=27ff64b0"
import script from "./Fiserv-widgets-guid.vue?vue&type=script&lang=js"
export * from "./Fiserv-widgets-guid.vue?vue&type=script&lang=js"
import style0 from "./Fiserv-widgets-guid.vue?vue&type=style&index=0&id=27ff64b0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports